
interface PaymentRowProps {
    label: string;
    value: string;
    icon?: React.ReactNode;
  }
  
export default function PaymentRow({ label, value, icon }: PaymentRowProps) {
    return (
        <div className="flex justify-between items-center py-1">
            <span className="text-gray-600 text-sm">{label}</span>
            <div className="flex items-center gap-2">
                {icon}
                <span className="text-[#3A3A3A] font-medium text-sm">{value}</span>
            </div>
        </div>
)}